import { object, string, array } from 'yup'

export const requestTourFormValidation = object({
  selectedDates: array().min(1, 'At least one date must be selected').required('Required'),
  message: string().optional(),
})
